/* eslint-disable global-require */
module.exports = ['marketplace.free._show.html.m2', 'marketplace.free._show.html.m3', 'marketplace.free._show.html.m5'];
